import React, { Component } from 'react';
import $ from 'jquery';
import Row from 'components/layout/grid/Row';
import Col from 'components/layout/grid/Col';
import Button from 'components/ui/button/Button';
import { IContext, IDispatch } from 'context/reducers';

type Props = {
  context: IContext;
};

export default class Welcome extends Component<Props> {
  dispatch: IDispatch;

  wrapperRef: any;

  constructor(props) {
    super(props);
    const {
      context: { dispatch },
    } = this.props;

    this.wrapperRef = null;
    this.dispatch = dispatch;
  }

  componentDidMount = () => {
    const {
      context: { showWelcome },
    } = this.props;

    if (showWelcome) {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  };

  componentWillUnmount = () => {
    this.closeModal();
  };

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  closeModal = () => {
    document.removeEventListener('mousedown', this.handleClickOutside);

    $('#Welcome').modal('hide');

    this.dispatch({
      type: 'SHOW_WELCOME',
      showWelcome: false,
    });
  };

  handleClickOutside = event => {
    const {
      context: { showWelcome },
    } = this.props;

    if (
      (this.wrapperRef && !this.wrapperRef.contains(event.target) && showWelcome) ||
      !showWelcome
    ) {
      this.closeModal();
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  };

  render(): JSX.Element {
    const {
      context: { showWelcome },
    } = this.props;

    if (showWelcome) {
      $('#Welcome').modal('show');
    } else {
      $('#Welcome').modal('hide');
    }

    return (
      <>
        {showWelcome && (
          <div
            className={`modal fade ${showWelcome ? 'show' : ''}`}
            id="Welcome"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="Welcome"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              ref={this.setWrapperRef}
              role="document"
            >
              <div className="modal-content bg-purple" style={{ zIndex: 20 }}>
                <div className="modal-body p-5">
                  <Row>
                    <Col lg="12">
                      <h2 className="text-color-white text-center pt-4">
                        BEM-VINDO AO VOALÁ
                      </h2>
                    </Col>
                    <Col lg="12">
                      <p className="text-color-white text-center pt-4">
                        Uma forma simples de tirar férias ou simplesmente viajar por
                        ai, sem dor de cabeça, seja sozinho ou em grupo. So decidir
                        para onde quer ir, montar seu plano de viagem e{' '}
                        <span className="text-color-orange text-bold">Voalá!</span>{' '}
                        Simples, não? =p
                      </p>
                    </Col>
                    <Col lg="12">
                      <Button className="btn-orange cm-h" onClick={this.closeModal}>
                        <span>#vaidevoala</span>
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
